import type { ReactNode } from 'react';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, type ModalProps, type SpaceProps } from 'antd';
import isObject from 'lodash/isObject';

import type { PosModalTabsProps } from './Tabs/PosModalTabs.tsx';
import { PosModalBanner } from './PosModalBanner.tsx';
import { PosModalHeader, type PosModalHeaderProps } from './PosModalHeader.tsx';

import './PosModal.css';

const isPosModalHeader = (
  val: PosModalHeaderProps | ReactNode
): val is PosModalHeaderProps =>
  isObject(val) ? !Object.hasOwn(val, '$$typeof') : false;

type AntdModalProps = Omit<
  ModalProps,
  | 'okButtonProps'
  | 'okText'
  | 'onOk'
  | 'okType'
  | 'cancelButtonProps'
  | 'cancelText'
  | 'closeIcon'
  | 'content'
  | 'title'
  | 'width'
>;

export interface PosModalProps extends AntdModalProps {
  header?: PosModalHeaderProps | ReactNode;
  bannerType?: 'error' | 'success' | 'loading' | undefined;
  expandable?: boolean;
  resizable?: boolean;
  draggable?: boolean;
  width?: number | string;
  tabs?: PosModalTabsProps;
  footerProps?: SpaceProps;
}

export const PosModal = ({
  header,
  bannerType,
  expandable,
  resizable,
  draggable,
  centered = true,
  maskClosable = false,
  children,
  width,
  footer,
  footerProps,
  tabs,
  ...props
}: PosModalProps) => {
  return (
    <Modal
      closeIcon={<FontAwesomeIcon icon={faXmark} />}
      centered={centered}
      maskClosable={maskClosable}
      width={width}
      className="posModal"
      title={
        isPosModalHeader(header) ? (
          <PosModalHeader hasTabs={!!tabs} {...header} />
        ) : (
          header
        )
      }
      footer={footer}
      {...props}
    >
      {bannerType && <PosModalBanner bannerType={bannerType} />}
      {children}
    </Modal>
  );
};
